import { Flex, Text, VStack, Box, Image, HStack } from "@chakra-ui/react"
import PhoneImg from '../../assets/phone.svg'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect } from "react"
import { ButtonPrimary } from "../ButtonPrimary";
import { ButtonSecondary } from "../ButtonSecondary";
export const About = () =>{

    useEffect(()=>{
        gsap.registerPlugin(ScrollTrigger)

        gsap.from(".leftAbout", {
            x: -200,
            opacity: 0,
          });
          gsap.to(".leftAbout", {
            x: 0,
            opacity: 1,
            duration: 2,
            scrollTrigger: {
              trigger: "#about",
              toggleActions: "restart play",
            },
          });


        gsap.from(".rightAbout", {
            x: 200,
            opacity: 0,
        });
        gsap.to(".rightAbout", {
            x: 0,
            opacity: 1,
            duration: 2,
            scrollTrigger: {
            trigger: "#about",
            toggleActions: "restart play",
            },
        });

        
    },[])
    return(
        <Flex
            v="100%"
            h="100vh"
            bg="blue.500"
            flexDir="row-reverse"
            justifyContent="space-between"
            overflowX="hidden"
            id="about"
        >
            <Flex
                padding="50px"
                flexDir="column"
                className="rightAbout"
            >
               <Text mt="25px" fontSize="lg">Sobre</Text>
               <Text fontSize="4xl" fontWeight="bold">Dê uma olhada em quem eu sou</Text>
               <VStack mt="80px" >
                   <Box
                        display="flex"
                        flexDir="column"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        w="100%"
                    >
                        <Text  
                            as="h2"
                            fontSize="lg"
                            fontWeight="bold"
                        >
                            Quem eu sou 
                        </Text>
                        <Text 
                            as="p"
                            color="gray.300"
                            w={["300px", "300px", "500px", "500px"]}
                        >
                            Apaixonado por tecnologia.

Me interesso por tecnologia desde pequeno, no começo eu gostava bastante de brincar com hardware mas com o passar do tempo comecei a me interessar mais e mais pela área de desenvolvimento de softwares. Cursei um tempo de sistemas de informação, mas por conta da pandemia o curso teve uma pausa e foi quando eu comecei a estudar programação por conta própria.
                        </Text>
                   </Box>
                   <Box 
                        display="flex"
                        flexDir="column"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        w="100%"
                    >
                        <Text  
                            as="h2"
                            fontSize="lg"
                            fontWeight="bold"
                        >
                            Skills
                        </Text>
                        <Text 
                            as="p"
                            color="gray.300"
                            w={["300px", "300px", "500px", "500px"]}
                            mb="10"
                        >
                            JavaScript, HTML5, CSS3, React.js, Styled-components, Flutter, PHP, Laravel, ChakraUI, GIT, TypeScript, Redux.js, ContextAPI, Python, Flask, PostgreSQL, MongoDB, ORM
                        </Text>
                        <HStack spacing="6">
                            <ButtonPrimary isExternal href="https://www.linkedin.com/in/gustavo-oliveira01011/"> Linkedin</ButtonPrimary>
                            <ButtonSecondary isExternal href="https://github.com/gustavool1">Github</ButtonSecondary>
                              
                        </HStack>
                   </Box>
               </VStack>
            </Flex>
            <Image 
                className="leftAbout"
                display={["none", "none", "block", "block"]}
                src={PhoneImg}
                w="40%"
            />
        </Flex>
    )
}